import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { mockRequests } from '../components/MockData';

// API 기본 URL 설정
const API_BASE_URL = 'https://kmhak.com'; // 실제 API URL로 변경 필요

// JWT 토큰 가져오기
export const getAuthToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens.idToken.toString();
  } catch (error) {
    console.error('인증 토큰을 가져오는 중 오류 발생:', error);
    throw error;
  }
};

// 인증이 필요한 API 요청 함수
export const authenticatedFetch = async (endpoint, options = {}) => {
  try {
    // 현재 인증된 사용자 확인
    await getCurrentUser();
    
    // JWT 토큰 가져오기
    const token = await getAuthToken();
    
    // 헤더에 인증 토큰 추가
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers
    };
    
    // API 요청
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers
    });
    
    // 응답 확인
    if (!response.ok) {
      throw new Error(`API 요청 실패: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API 요청 중 오류 발생:', error);
    throw error;
  }
};

export const fetchRequests = async () => {
   return authenticatedFetch('/api/aigent/requests');
};

// shortenPk를 사용하여 pre-signed URL 요청
export const getPresignedUrl = async (shortenPk) => {
  return authenticatedFetch('/api/aigent/presigned-url', {
    method: 'POST',
    body: JSON.stringify({ shortenPk })
  });
};

// 채널 관련 API 함수들
export const fetchChannels = async () => {
  return authenticatedFetch('/api/channels');
};

export const createChannel = async (channelData) => {
  return authenticatedFetch('/api/channels', {
    method: 'POST',
    body: JSON.stringify(channelData)
  });
};

export const updateChannel = async (channelPk, channelData) => {
  return authenticatedFetch(`/api/channels/${encodeURIComponent(channelPk)}`, {
    method: 'PUT',
    body: JSON.stringify(channelData)
  });
};

export const deleteChannel = async (channelPk) => {
  return authenticatedFetch(`/api/channels/${encodeURIComponent(channelPk)}`, {
    method: 'DELETE'
  });
};

export const testChannel = async (channelPk) => {
  return authenticatedFetch(`/api/channels/${encodeURIComponent(channelPk)}/test`, {
    method: 'POST'
  });
};

// 프로젝트 관련 API 함수들
export const fetchProjects = async () => {
  return authenticatedFetch('/api/projects');
};

export const createProject = async (projectData) => {
  return authenticatedFetch('/api/projects', {
    method: 'POST',
    body: JSON.stringify(projectData)
  });
};

export const updateProject = async (projectId, projectData) => {
  return authenticatedFetch(`/api/projects/${projectId}`, {
    method: 'PUT',
    body: JSON.stringify(projectData)
  });
};

export const deleteProject = async (projectId) => {
  return authenticatedFetch(`/api/projects/${projectId}`, {
    method: 'DELETE'
  });
};

export const fetchAudioTranscription = async (pk) => {
  return authenticatedFetch(`/api/audio/${pk}/transcription`);
};

export const fetchAudioSummary = async (pk) => {
  return authenticatedFetch(`/api/audio/${pk}/summary`);
};

// 사용자 프로필 조회
export const fetchUserProfile = async () => {
  return authenticatedFetch('/api/user/profile');
};
